const type = 'SET_NEW_CARD_OUTCOME';

const setNewCardOutcome = (data) => ({
  data,
  type,
});

export { type };
export default setNewCardOutcome;
